import {
  PrivateImg,
  type PrivateImgProps,
} from "@winamp/media-upload/BytescaleContext/PrivateImg.js";
import { CoverPlaceholder } from "@winamp/ui/components/CoverPlaceholder/CoverPlaceholder.js";
import { classNames } from "@winamp/ui/utils/classNames.js";
import { Link, type LinkProps } from "react-router";

export function ServiceDetailsCard({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"div">) {
  return (
    <div
      className={classNames(
        "flex flex-col gap-4 border border-primary rounded-xl p-6 pb-8 w-full h-fit",
        className,
      )}
      {...props}
    />
  );
}

export function ServiceDetailsCardCover({
  className,
  ...props
}: Omit<PrivateImgProps, "children">) {
  return (
    <PrivateImg
      className={classNames(
        "object-cover w-full h-auto rounded-xl aspect-square",
        className,
      )}
      {...props}
    >
      <CoverPlaceholder
        className={classNames(
          "object-cover w-full h-auto rounded-md aspect-square",
          className,
        )}
      />
    </PrivateImg>
  );
}

export function ServiceDetailsCardTitle({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"h3"> | LinkProps) {
  return "to" in props ? (
    <Link
      className={classNames(
        "font-semibold text-primary text-xl hover:underline",
        className,
      )}
      {...props}
    />
  ) : (
    <h3
      className={classNames("font-semibold text-primary text-xl", className)}
      {...props}
    />
  );
}

export function ServiceDetailsCardDescription({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"span">) {
  return (
    <span
      className={classNames(
        "text-secondary text-sm font-normal break-words",
        className,
      )}
      {...props}
    />
  );
}

export function ServiceDetailsCardError({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"span">) {
  return (
    <span
      className={classNames("text-error text-sm font-normal", className)}
      {...props}
    />
  );
}
